import { render, staticRenderFns } from "./user_level_edit.vue?vue&type=template&id=4ca06b62&scoped=true"
import script from "./user_level_edit.vue?vue&type=script&lang=js"
export * from "./user_level_edit.vue?vue&type=script&lang=js"
import style0 from "./user_level_edit.vue?vue&type=style&index=0&id=4ca06b62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca06b62",
  null
  
)

export default component.exports